/**
 * Document title and meta description.
 *
 * This is a client-rendered SPA, so search engines that do not execute
 * JavaScript will not see these. That is a deliberate, documented trade-off for
 * the first version — if organic search matters more later, the fix is to
 * pre-render the product and collection routes at build time rather than to
 * bolt a framework on.
 */

import { useEffect } from 'react';

function setMeta(name: string, content: string): void {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = name;
    document.head.appendChild(tag);
  }
  tag.content = content;
}

function setOg(property: string, content: string): void {
  let tag = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.content = content;
}

export function usePageMeta(meta: {
  title: string;
  description?: string;
  image?: string | null;
}): void {
  useEffect(() => {
    if (!meta.title) return;
    document.title = meta.title;
    setOg('og:title', meta.title);
    setOg('og:type', 'website');
    setOg('og:url', window.location.href);

    if (meta.description) {
      setMeta('description', meta.description);
      setOg('og:description', meta.description);
    }
    if (meta.image) {
      setOg('og:image', meta.image);
    }
  }, [meta.title, meta.description, meta.image]);
}
